// Runtime config from Vite env (VITE_* are inlined at build time).
const env = import.meta.env as Record<string, string | undefined>;

function trimSlash(u: string): string {
  return u.replace(/\/+$/, "");
}

export const AUTH_BASE = trimSlash(
  env.VITE_AUTH_BASE ??
    "https://averer-accounts-dev-1066175777872.australia-southeast1.run.app",
);

export const SIBLING_LABEL = env.VITE_SIBLING_LABEL ?? "Averer Investors";
export const SIBLING_URL = env.VITE_SIBLING_URL ?? "";
export const TOKENISER_URL = env.VITE_TOKENISER_URL ?? "";
